import React from 'react';
import LoadingSection from '../../LoadingSection/LoadingSection';
import { PerksListContainer, PRICE_ID_CONTAINER } from '../shared';
import styles from '../shared/SharedPlanStyles.module.scss';
import seasonalStyles from './SeasonalPlanCard.module.scss';
import { SeasonalPlanCardProps } from '../shared/interfaces';

const SeasonalPlanCard: React.FC<SeasonalPlanCardProps> = ({
  perksList,
  title,
  disclaimer,
  price,
  isLoadingPrice,
  onSelectPlan,
  isSelected,
  subtitle,
}): JSX.Element => {
  return (
    <div
      onClick={onSelectPlan}
      role="button"
      tabIndex={0}
      onKeyDown={onSelectPlan}
      id="seasonal-plan"
      className={`
          ${styles.planCardContainer} 
          ${isSelected ? styles.plansOptionsSelected : ''}
        `}
    >
      <div className={styles.planSelectedLabel}>Selected Plan</div>
      <div className={styles.plansContent}>
        <div className={styles.plansPriceContainer}>
          <div className={styles.plansTitle}>
            <h4>{title}</h4>
          </div>
          <p className={seasonalStyles.planSubTitle}>{subtitle}</p>
          <p data-testid={PRICE_ID_CONTAINER} className={styles.plansContentPrice}>
            ${!isLoadingPrice ? price : <LoadingSection height={42} width={125} />} <span>USD</span>
          </p>
          <div className={seasonalStyles.planDisclaimer}>{disclaimer}</div>
        </div>
        <hr className={styles.plansLineDivider} />
        <PerksListContainer perksList={perksList} />
      </div>
    </div>
  );
};

export default SeasonalPlanCard;
